import httpClient from '@/_shared/http-client';
import { date } from '@/_shared/utils';

const PRIMARY_SLUG = 'analytics';

const getForWork = async(params) => {
  const url = new URL(`/${PRIMARY_SLUG}/work`, process.env.BACKEND_URL);
  params.current_date = date.getIsoString();
  for (let paramName in params) {
    url.searchParams.set(paramName, params[paramName]);
  }
  const response = await httpClient.get(url);
  return response;
};

const getUserProducts = async(params) => {
  const baseUrl = process.env.BACKEND_URL;
  const url = new URL(`/${PRIMARY_SLUG}/work/products`, baseUrl);
  for (let paramName in params) {
    url.searchParams.set(paramName, params[paramName]);
  }
  const response = await httpClient.get(url);
  return response;
};

export const analyticsService = {
  getForWork,
  getUserProducts,
};



// WEBPACK FOOTER //
// ./src/_shared/api-services/analyticsService.js